var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthics4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "url(#paint0_linear_468_1539)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 19.1665H14.1667C13.2462 19.1665 12.5 19.9127 12.5 20.8332V26.6665C12.5 27.587 13.2462 28.3332 14.1667 28.3332H25.8333C26.7538 28.3332 27.5 27.587 27.5 26.6665V20.8332C27.5 19.9127 26.7538 19.1665 25.8333 19.1665Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 19.1665V15.8332C15.834 14.7281 16.273 13.6683 17.0544 12.8869C17.8358 12.1055 18.8956 11.6665 20.0007 11.6665C21.1057 11.6665 22.1655 12.1055 22.9469 12.8869C23.7283 13.6683 24.1673 14.7281 24.1673 15.8332V19.1665",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_1539",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00786F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthics4);
export default __webpack_public_path__ + "static/media/Ethics-4.028bd77d770cb90ad356fb373a4af351.svg";
export { ForwardRef as ReactComponent };